type Props = {
  id: string;
  label: string;
  options: string[];
  value: string[];
  onChange: (next: string[]) => void;
  error?: string;
};

export function ChipSelect({ id, label, options, value, onChange, error }: Props) {
  const toggle = (opt: string) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  const groupId = `${id}-group`;
  return (
    <div
      role="group"
      aria-labelledby={groupId}
      aria-describedby={error ? `${id}-error` : undefined}
    >
      <span id={groupId} className="field-label">
        {label}
      </span>
      <div className="chips">
        {options.map((opt) => {
          const pressed = value.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              className="chip"
              aria-pressed={pressed}
              onClick={() => toggle(opt)}
            >
              {opt}
            </button>
          );
        })}
      </div>
      <div className="field-counter" aria-live="polite">
        {value.length > 0 ? `${value.length} selected` : "None selected"}
      </div>
      {error && (
        <div id={`${id}-error`} className="field-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
